(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hcs-mega-nav"] && !Shopify.designMode) return;
  try {
    (function () {
  var panel = document.getElementById('hcs-nav-panel');
  var nav = document.querySelector('.hcs-nav__top');
  if (nav && panel) {
    var triggers = nav.querySelectorAll('.hcs-nav__trigger');
    var panes = panel.querySelectorAll('.hcs-nav__pane');
    var closeTimer;

    function openPane(key) {
      clearTimeout(closeTimer);
      triggers.forEach(function (b) {
        var on = b.getAttribute('data-hcs') === key;
        if (b.tagName === 'BUTTON') b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      panes.forEach(function (p) {
        p.classList.toggle('is-on', p.id === 'hcs-pane-' + key);
      });
      panel.classList.add('is-open');
    }
    function closePane() {
      closeTimer = setTimeout(function () {
        panel.classList.remove('is-open');
        triggers.forEach(function (b) {
          if (b.tagName === 'BUTTON') b.setAttribute('aria-expanded', 'false');
        });
      }, 150);
    }

    triggers.forEach(function (b) {
      if (b.tagName !== 'BUTTON') return;
      var key = b.getAttribute('data-hcs');
      b.addEventListener('mouseenter', function () { openPane(key); });
      b.addEventListener('focus', function () { openPane(key); });
      b.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.classList.contains('is-open') && b.getAttribute('aria-expanded') === 'true') {
          panel.classList.remove('is-open');
          b.setAttribute('aria-expanded', 'false');
        } else {
          openPane(key);
        }
      });
    });

    nav.addEventListener('mouseleave', closePane);
    nav.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', closePane);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        panel.classList.remove('is-open');
        triggers.forEach(function (b) {
          if (b.tagName === 'BUTTON') b.setAttribute('aria-expanded', 'false');
        });
      }
    });
    document.addEventListener('click', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (panel.contains(e.target) || nav.contains(e.target)) return;
      panel.classList.remove('is-open');
      triggers.forEach(function (b) {
        if (b.tagName === 'BUTTON') b.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ---- Mobile sheet ----
  var sheet = document.getElementById('hcs-nav-sheet');
  var burger = document.getElementById('hcs-nav-burger');
  var closeBtn = document.getElementById('hcs-nav-sheet-close');
  var scrim = document.getElementById('hcs-nav-scrim');
  if (sheet && burger) {
    var lastFocus = null;
    function focusables() {
      return sheet.querySelectorAll('a[href], button:not([disabled])');
    }
    function openSheet() {
      lastFocus = document.activeElement;
      // Portal scrim + sheet to <body>: the header lives in a sticky, z-indexed
      // section that traps these fixed overlays in its stacking context (they
      // can't paint over page sections no matter their z-index). Moving them to
      // the body root lets the scrim dim everything and the sheet sit on top.
      if (scrim && scrim.parentNode !== document.body) document.body.appendChild(scrim);
      if (sheet.parentNode !== document.body) document.body.appendChild(sheet);
      if (scrim) { scrim.hidden = false; void scrim.offsetWidth; scrim.classList.add('is-open'); }
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('hcs-nav-drawer-open');
      document.body.style.overflow = 'hidden';
      void sheet.offsetWidth;
      if (closeBtn) closeBtn.focus();
    }
    function closeSheet() {
      sheet.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('hcs-nav-drawer-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    burger.addEventListener('click', openSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (scrim) scrim.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) {
      if (!sheet.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key === 'Tab') {
        var f = focusables();
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (!sheet.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    var tabs = sheet.querySelectorAll('.hcs-nav__tab');
    var mpanes = sheet.querySelectorAll('.hcs-nav__mpane');
    var body = sheet.querySelector('.hcs-nav__sheet-body');
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-hcs');
        tabs.forEach(function (x) {
          x.classList.toggle('is-on', x === b);
        });
        mpanes.forEach(function (p) {
          var on = p.id === 'hcs-mpane-' + key;
          p.classList.toggle('is-on', on);
          if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
        if (body) body.scrollTo(0, 0);
      });
    });
  }

  // ---- Suppress the Intercom launcher while a Klaviyo form popup is open ----
  // Klaviyo dispatches a 'klaviyoForms' event on window; detail.type is 'open'
  // when a popup/flyout shows and 'close' when it dismisses. Toggle the shared
  // .hcs-suppress-chat class on <html> so the CSS above hides Intercom.
  window.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    var root = document.documentElement;
    if (e.detail.type === 'open') {
      root.classList.add('hcs-suppress-chat');
    } else if (e.detail.type === 'close') {
      root.classList.remove('hcs-suppress-chat');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
